import "./App.css";
import { BrowserRouter, useLocation, useNavigate, Link, } from "react-router-dom";
import { useContext, useEffect, useMemo, useState } from "react";
import UserDetailsContextProvider, { UserContext } from "./context/UserDetails";
import WishListItemsContextProvider from "./context/WishListItems";
import CartItemsContextProvider from "./context/CartItems";
import GlobalStyles from "./styles/GlobalStyles";
import AppStu from "./AppStu";
import AppEmp from "./AppEmp";
import AppGuest from "./AppGuest";
import { employeeRoutes, guestRoutes, studentRoutes } from "./AppConfig";
import { Modal } from "react-bootstrap";
// -------------------- Helper Functions --------------------
const flattenRoutes = (routes, basePath = "") =>
  routes.flatMap((route) => {
    const fullPath = `${basePath}${route.path === "/" ? "" : "/" + route.path
      }`.replace(/\/+/g, "/");
    const children = route.children
      ? flattenRoutes(route.children, fullPath)
      : [];
    return [fullPath, ...children];
  });
const matchPath = (routePath, currentPath) => {
  const pattern = new RegExp("^" + routePath.replace(/:\w+/g, "[^/]+") + "$");
  return pattern.test(currentPath);
};
// -------------------- Inline ConfirmationPopup --------------------
const ConfirmationPopup = ({
  title,
  message,
  onConfirm,
  onCancel,
  open,
  confirmLable,
  hideCloseIcon = false,
}) => (
  <Modal show={open} onHide={onCancel} size="md" centered>
    <Modal.Header closeButton={!hideCloseIcon}>
      <Modal.Title>
        <h5 className="ModalHeader mb-0">{title}</h5>
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div className="mb-4 col-md-12">
        <div className="alert alert-danger mb-0 p-2 d-flex align-items-center">
          <span
            className="material-icons text-danger me-2"
            style={{ fontSize: "1.8rem" }}
          >
            warning
          </span>
          <strong>{message}</strong>
        </div>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <div className="d-flex justify-content-end w-100">
        <ul className="List-Button">
          {confirmLable !== "OK" && (
            <li className="ListBtnItems">
              <Link onClick={onCancel} to="#" className="secondaryButton">
                No, Keep It
              </Link>
            </li>
          )}
          <li className="ListBtnItems">
            <Link to="#" onClick={onConfirm} className="primaryButton">
              {confirmLable || "Yes, Remove"}
            </Link>
          </li>
        </ul>
      </div>
    </Modal.Footer>
  </Modal>
);
// -------------------- Role Based Routing --------------------
const RoleBasedApp = () => {
  const { user, logout } = useContext(UserContext);
  const location = useLocation();
  const navigate = useNavigate();
  const [modalMessage, setModalMessage] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const { studentPaths, employeePaths, guestPaths } = useMemo(
    () => ({
      studentPaths: flattenRoutes(studentRoutes),
      employeePaths: flattenRoutes(employeeRoutes),
      guestPaths: flattenRoutes(guestRoutes),
    }),
    []
  );
  const showModal = (msg) => {
    setModalMessage(msg);
    setModalOpen(true);
  };
  const handleModalClose = () => {
    setModalOpen(false);
    setModalMessage("");
    sessionStorage.clear();
    localStorage.clear();
    logout?.();
    navigate("/login", { replace: true });
  };
  useEffect(() => {
    const currentPath = location.pathname.replace(/\/$/, "");
    if (!user) {
      // navigate("/login");
      return;
    }
    const userType = Number(user.user_type); //  make sure it's numeric
    let message = "";
    if (!userType) {
      if (!guestPaths.some((p) => matchPath(p, currentPath))) {
        message =
          "You don't have access to this page and will be redirected to login.";
      }
    } else if (
      [1, 3, 4, 5].includes(userType) &&
      !employeePaths.some((p) => matchPath(p, currentPath)) &&
      !guestPaths.some((p) => matchPath(p, currentPath))
    ) {
      message =
        "You will be logged out and redirected to login. Please contact the administrator.";
    } else if (
      userType === 2 &&
      !studentPaths.some((p) => matchPath(p, currentPath)) &&
      !guestPaths.some((p) => matchPath(p, currentPath))
    ) {
      message =
        "You will be logged out and redirected to login. Please contact the administrator.";
    }
    if (message) {
      showModal(message);
    }
  }, [location.pathname, user, guestPaths, employeePaths, studentPaths]);
  if (modalOpen) {
    return (
      <ConfirmationPopup
        open={modalOpen}
        title="Access Denied : Unauthorized Access"
        message={modalMessage}
        confirmLable="OK"
        onConfirm={handleModalClose}
        hideCloseIcon={true}
      />
    );
  }
  const userType = Number(user?.user_type);
  if ([1, 3, 4, 5].includes(userType)) return <AppEmp />;
  if (userType === 2) return <AppStu />;
  return <AppGuest />;
};
// -------------------- App Wrapper --------------------
const App = () => (
  <div className="App">
    <UserDetailsContextProvider>
      <WishListItemsContextProvider>
        <CartItemsContextProvider>
          <BrowserRouter>
            <GlobalStyles />
            <RoleBasedApp />
          </BrowserRouter>
        </CartItemsContextProvider>
      </WishListItemsContextProvider>
    </UserDetailsContextProvider>
  </div>
);
export default App;